export default __webpack_public_path__ + "static/MediaContentTen-11022da2bf37f350bb4fa5e7312ea8b3.webp";